import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getAlGroupsForDropdown,
    getFactoriesByGroupID,
    getgreenLeafReportData,
    getCustomerIDs
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetFactoriesByGroupID', 'groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getCustomerIDs(operationEntityID) {
    const response = await CommonGet('/api/GreenleafCustomerSummaryReport/GetCustomerIDToGreenleafCustomerSummaryReport', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function getgreenLeafReportData(data) {
    var model = {
        operationEntityID: parseInt(data.operationEntityID),
        date: data.date
    };
    const response = await CommonPost('/api/GreenleafCustomerSummaryReport/GetDataToGreenleafCustomerSummaryReport', null, model);
    return response.data;
}
